import { makeCompanyUrl, removeSomeSpecialChars } from "@/helpers/jobs";
import Image from "next/image";
import React from "react";

type JobCompanyNewProps = {
  jobData: jobDescriptionType;
  isMobile: boolean;
  mediaUrl: string;
};

const JobCompany: React.FC<JobCompanyNewProps> = ({
  jobData,
  isMobile,
  mediaUrl,
}) => {
  const {
    hideCompanyName,
    companyName = "",
    companyLogoUrl = "",
    companyId = 0,
    isMicrosite,
    micrositeUrl,
    redirectUrl,
    jobSource,
    companyProfile = "",
  } = jobData;

  const companyUrl = makeCompanyUrl(
    companyId,
    companyName,
    isMicrosite,
    micrositeUrl,
  );

  const companyDescription = removeSomeSpecialChars(companyProfile, "?¿�~");

  const showCompanyName = Boolean(!hideCompanyName && companyName);

  if (!showCompanyName || companyName === "Confidential") return null;

  const logoSrc =
    !hideCompanyName && companyLogoUrl
      ? companyLogoUrl
      : companyName === "Confidential" || (!companyName && hideCompanyName)
        ? `https://${mediaUrl}/public/core/images/companyLogoConfidential.png`
        : `https://${mediaUrl}/public/core/images/companyLogoDefault.png`;

  const logoAlt = companyName || "Confidential";

  const showJobSource = Boolean(jobSource === "SCRAPPING" && redirectUrl);

  const companyNameSection = (
    <a
      href={companyUrl}
      target="_blank"
      className="!text-content-primary text-base font-medium leading-6 hover:underline"
      style={{ color: "#17142A !important" }}
    >
      {companyName}
    </a>
  );

  const companyProfileSection = companyProfile && (
    <p
      className={`text-content-secondary text-sm leading-[22px] md:!text-base md:!leading-[26px] ${isMobile ? "mt-3" : "mt-2"}`}
      dangerouslySetInnerHTML={{ __html: companyDescription }}
    ></p>
  );

  const aboutCompanySection = (
    <div className="flex flex-col gap-3">
      <h2 className="text-content-primary text-lg font-bold leading-[26px]">
        About Company
      </h2>
      <div className="flex items-center justify-between">
        <div
          className={`flex items-center gap-2 ${companyLogoUrl && "md:!border-surface-tertiary md:!size-11 md:!rounded md:!border md:!border-solid"}`}
        >
          {!isMobile && (
            <Image src={logoSrc} alt={logoAlt} height={44} width={44} />
          )}
          <div className="flex flex-col gap-2">
            <label className="line-clamp-2 text-sm font-normal md:!w-max md:!text-base">
              {companyNameSection}
            </label>
          </div>
        </div>
      </div>
      {companyProfileSection}
    </div>
  );

  return (
    <div
      id="jobCompany"
      className="border-border-subtle border-t border-solid p-4 md:!p-6"
    >
      {aboutCompanySection}
    </div>
  );
};

export default JobCompany;
